module.exports = __webpack_public_path__ + "static/media/suit-3.67dee7be.jpg";